import React from 'react'
import '../../styles/scss/components/equote-package-details-cruise-highlights.scss'

const EQuotePreviewPackageCruiseHighlights = ({
  brandClassName,
  brandDetails
}) => {
  return (
    <div className="equote-package-details-cruise-highlights">
      <h1 className={`section-title ${brandClassName} u-text-center`}>
        Brand Highlights
      </h1>
      <div
        className={`equote-package-details-cruise-highlights--text ${brandClassName} u-text-center`}
      >
        {brandDetails && (
          <div>
            {Boolean(brandDetails && brandDetails.features.length) &&
              brandDetails.features.map((feature, i) => (
                <p key={i}>{feature}</p>
              ))}
            <p
              dangerouslySetInnerHTML={{
                __html: brandDetails.highlights.replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br>'
                )
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default EQuotePreviewPackageCruiseHighlights
